module.exports = "/_next/static/images/award-info-bank-c8feedf4eb83955a8766591ee1f0632e.png";